<template>
  <div class="container">
    <div class="message-cnt">
		<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
			<el-tab-pane label="我的留言" name="messagemy">
				<div class="message-wrap">
					<div class="message" v-for="item in dataList" :key="item.id">
						<messageItem :isMessageMy="true" :isCutLine="false" @toDetail="toDetail" @toDelete="toDelete" :item="item" :isShowHeadPic="false"/>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="我的回复" name="replaymy">
				<div class="message-wrap">
					<div class="message" v-for="item in dataList" :key="item.id">
						<messageItem :isMessageMy="true" :isCutLine="false" @toDetail="toDetail" @toDelete="toDelete" :item="item" :isShowHeadPic="false"/>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<ContentNo content="暂时没有内容" v-if="dataList.length<=0"/>
		<div class="page-size"  v-if="dataList.length>0">
			<el-pagination
			background
			layout="prev, pager, next"
			:page-size= this.pageSize
			:total=this.total
			@current-change="handleCurrentChange"
			:current-page = "pageNum"
			hide-on-single-page
			>
			</el-pagination>
		</div>
	</div>
  </div>
</template>

<script>
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import ContentNo from '@/components/contentno'
import messageItem from '@/components/Message/messageItem.vue'
export default {
  name: 'messageMy',
  components: {
    ContentNo,
	messageItem
  },
  data(){
	return{
		activityId: '',
		userId: '',
		pageNum: 1,
		pageSize: 8,
		dataList: [],
		total: 0,
		activeTab: 'messagemy'
	}
  },
  methods: {
	toDetail(){
		localStorage.setItem('isMessageMy', true)
	},
	toDelete(e){
		this.$confirm('确定要删除此条留言吗？','温馨提示',{
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async()=>{
			this.getDelete(e.id)
		}).catch(()=>{
			
		})
	},
	//删除留言
	async getDelete(id){
		let url = 'v1/suggest/delete'
		let param = {
			id: id
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.$message.success('删除成功')
			this.dataList.forEach((item,index)=>{
				if(item.id==id){
					this.dataList.splice(index,1)
				}
			})
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//留言列表
	async getDataList(type){
		let url = type=='messagemy'?'v1/suggest/myList':'v1/suggest/myReply'
		let param = {
			activityId: this.activityId,
			addUserId: this.userId,
			pageNum: this.pageNum,
			pageSize: this.pageSize
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.dataList = res.data.list
			this.total = res.data.total
		} else {
			this.$message.error(res.data.msg)
		}
	},
	handleClick(tab) {
		this.activeTab = tab.name
		this.dataList = []
		this.pageNum = 1
		this.getDataList(tab.name)
	},
	handleCurrentChange(e){
		this.dataList = []
		this.pageNum = e
		this.getDataList(this.activeTab)
	}
  },
  created(){
	this.userId = localStorage.getItem('userId')
	this.activityId = localStorage.getItem('activityId')
	this.getDataList('messagemy')
  }
}
</script>

<style scoped lang="less">
	.message-cnt{
		float: right;
		width: 88%;
		min-height: 400px;
		box-sizing: border-box;
	}
	.message /deep/ .message-title-wrap,.message /deep/ .message-tips {
		margin-left: 0
	}
	.message-cnt /deep/ .el-tabs__item{
		font-weight: bold;
	}
	.message-cnt /deep/ .el-tabs__item.is-active,.message-cnt /deep/ .el-tabs__item:hover{
		color: #DE0515
	}
	.message-cnt /deep/ .el-tabs__active-bar{
		background-color: #DE0515;
	}
	.message-cnt /deep/ .message-list{
		border-width: 1px;
	}
	.message-cnt /deep/ .el-tabs__nav-wrap::after {
		height: 1px;
		background-color: #f7f7f7;
	}
</style>
